import { FC } from "react"
import { SchedulesBatchUpdate } from "../../../module/schedules/containers/batchUpdate"

export const BatchUpdatePage: FC = () => <SchedulesBatchUpdate />
